<template>
    <div class="flex-form__field flex-form__field--code" :class="getInvalidClass('code')">
        <div class="flex-form__label">
            JAVASCRIPT CODE

            <button class="flex-form__action" @click="onFullScreen">
                Full Screen Mode
            </button>
        </div>

        <div class="js-editor" :class="fullScreenClass" @click="onAnyClick">
            <div v-if="isFullScreen" class="js-editor__toolbar">
                <h4 class="js-editor__title">
                    Code Editor
                </h4>

                <dropdown
                    class="js-editor__dropdown"
                    placeholder="Insert Snippet"
                    :options="toolbarOptions"
                    @input="onInsertSnippet"
                />

                <button class="js-editor__close" @click="isFullScreen = false">
                    <font-awesome-icon :icon="['fal', 'times']" />
                </button>
            </div>

            <rich-html-editor
                mode="javascript"
                theme="code"
                :input="editorCode"
                :resize="forceEditorResize"
                @change="onChange"
            />
        </div>
    </div>
</template>

<script>
import eventDataMixin from '@/mixins/event-data';
import RichHtmlEditor from '@/components/shared/modal/rich-html-editor';
import { STATE_CLASSES } from '@/data/constants/classes';
import snippets from '@/data/snippets/all';

export default {
    name: 'action-run-javascript',
    components: { RichHtmlEditor },
    mixins: [eventDataMixin],

    data() {
        return {
            isFullScreen: false,
            editorCode: '',
            forceEditorResize: false,

            schema: {
                code: {
                    type: String,
                    default: '',
                    required: true,
                },

                targetType: {
                    type: String,
                    default: 'self',
                },
            },
        };
    },

    computed: {
        fullScreenClass() {
            return this.isFullScreen ? STATE_CLASSES.EXPANDED : '';
        },

        toolbarOptions() {
            return Object.entries(snippets).map((entry) => {
                const [name, data] = entry;

                return {
                    text: data.label,
                    value: name,
                };
            });
        },
    },

    async mounted() {
        await this.$nextTick();

        this.editorCode = this.dataNew.code;
    },

    methods: {
        onChange(codeStr) {
            this.dataNew.code = codeStr;
        },

        onAnyClick() {
            this.$root.$emit('flex::dropdown::close');
        },

        onFullScreen() {
            this.isFullScreen = true;
            this.onResize();
        },

        onInsertSnippet(snippetName) {
            const snippet = snippets[snippetName].code;

            this.editorCode = snippet;
            this.dataNew.code = snippet;
            this.onResize();
        },

        async onResize() {
            this.forceEditorResize = true;
            await this.$nextTick();
            this.forceEditorResize = false;
        },
    },
};
</script>

<style lang="scss">
.rich-html-editor--code {
    padding: 0;
    height: 250px;

    .ace_gutter-cell.ace_error {
        background-position: 0.125em 0.1375em;
    }

    .ace_print-margin {
        display: none;
    }

    .#{ $is-expanded } & {
        height: 100%;
    }
}

.js-editor {
    text-transform: none;

    &.#{ $is-expanded } {
        position: fixed;
        top: 0;
        right: 0;
        left: -8%;
        bottom: 0;
        z-index: 250;
    }

    &__toolbar {
        display: flex;
        align-items: center;
        color: var(--modal-headerColor);
        background-image: linear-gradient(var(--modal-headerBackgroundColorTop), var(--modal-headerBackgroundColorBottom));
        padding: 5px;
        padding: 15px 25px;
    }

    &__title {
        font-size: 1.25rem;
        font-weight: 600;
    }

    &__dropdown {
        font-weight: 600;
        border-color: rgba(255, 255, 255, 0.5);
        margin-left: auto;
        width: 15em;
    }

    &__close {
        font-size: 1.75rem;
        margin-left: 3.5rem;
    }
}
</style>
